import { Builder } from "@builder.io/react";
import { FoundationIcon } from "../../../slate/icons/foundation/FoundationIcon";
import { BuilderConfig as FoundationIconConfig } from "../../../slate/icons/foundation/FoundationIcon.builder";
import { withTransformations } from "./withTransformations";
var _FoundationIconConfig_transformations;
var BuilderFoundationIcon = withTransformations(FoundationIcon, (_FoundationIconConfig_transformations = FoundationIconConfig.transformations) !== null && _FoundationIconConfig_transformations !== void 0 ? _FoundationIconConfig_transformations : {});
export var registerBuilderFoundationIcon = function() {
    Builder.registerComponent(BuilderFoundationIcon, {
        name: "FoundationIcon",
        hideFromInsertMenu: false,
        inputs: [
            {
                name: "iconName",
                type: "string",
                enum: [
                    "Account",
                    "Add",
                    "AddFile",
                    "AddUser",
                    "AlarmClock",
                    "Announcement",
                    "AnnouncementMuted",
                    "Apple",
                    "Application",
                    "ArchiveBox",
                    "Arrow",
                    "ArrowAllDirections",
                    "BarGraph",
                    "Block",
                    "Book",
                    "Bookmark",
                    "BookmarkTag",
                    "Bottle",
                    "Bowl",
                    "BrokenLink",
                    "BrowserCheck",
                    "BrowserCode",
                    "BrowserRemove",
                    "BulkSelect",
                    "BusinessCard",
                    "Button",
                    "Calculation",
                    "Calendar",
                    "CartEmpty",
                    "CartItems",
                    "Caution",
                    "CautionSolid",
                    "ChatBubble",
                    "Check",
                    "CheckInCircle",
                    "CheckOutline",
                    "Cheese",
                    "Chevron",
                    "CircleFilled",
                    "Clipboard",
                    "Clock",
                    "ClockSolid",
                    "Close",
                    "Clover",
                    "Columns",
                    "Commitment",
                    "Computer",
                    "CreditCard",
                    "CurrencyConverter",
                    "CustomerSupport",
                    "Diamond",
                    "Divider",
                    "Dollar",
                    "DoubleChevron",
                    "Download",
                    "Duplicate",
                    "Earn",
                    "Edit",
                    "Ellipsis",
                    "Email",
                    "EstimatedDeliveryDate",
                    "Euro",
                    "Exclamation",
                    "ExclamationSolid",
                    "Exclusivity",
                    "Expand",
                    "ExpandedLayout",
                    "EyeOpen",
                    "EyeClosed",
                    "Eye",
                    "Facebook",
                    "File",
                    "FileMultiple",
                    "Filter",
                    "Finance",
                    "Glass",
                    "Global",
                    "Globe",
                    "Gmail",
                    "Google",
                    "Graph",
                    "Group",
                    "Hamburger",
                    "HappyFace",
                    "Heart",
                    "Home",
                    "HorizontalEllipsis",
                    "ImageLandscape",
                    "InStock",
                    "Information",
                    "Instagram",
                    "InterfaceSearch",
                    "Language",
                    "Leaf",
                    "Lightbulb",
                    "Link",
                    "LinkedIn",
                    "Location",
                    "FoundationLock",
                    "LockSquare",
                    "LockCircle",
                    "LockRoundBottom",
                    "LockFlatTop",
                    "LockRoundedSquare",
                    "Lock",
                    "MagicWand",
                    "Minimize",
                    "MobilePhone",
                    "Mug",
                    "NewTab",
                    "Notification",
                    "NotificationBell",
                    "NotificationBellChecked",
                    "OutOfStock",
                    "Outlook",
                    "OutlookColored",
                    "Paperclip",
                    "PartyPopper",
                    "PaymentPlan",
                    "Percentage",
                    "Phone",
                    "Pin",
                    "Pound",
                    "DollarPriceTag",
                    "PoundPriceTag",
                    "EuroPriceTag",
                    "PriceTag",
                    "Printer",
                    "QRCode",
                    "Redo",
                    "Relationships",
                    "ResponsibleConsumption",
                    "Returns",
                    "RewindClock",
                    "SadFace",
                    "SaleTag",
                    "Save",
                    "Search",
                    "Send",
                    "Settings",
                    "Share",
                    "ShareHeart",
                    "ShipmentDelivered",
                    "Shipping",
                    "ShipsFrom",
                    "Shopify",
                    "ShopifyColored",
                    "ShoppingBag",
                    "Shuffle",
                    "SingleColumn",
                    "SocialFacebook",
                    "SocialInstagram",
                    "SocialLinkedIn",
                    "SocialTwitter",
                    "SocialYouTube",
                    "Sort",
                    "Split",
                    "Sprout",
                    "Square",
                    "SquareLayout",
                    "Star",
                    "StarFilled",
                    "Storefront",
                    "Subtract",
                    "Synchronized",
                    "SynchronizedWarning",
                    "TextFormattingJustified",
                    "TextFormattingStyle",
                    "ThumbsDown",
                    "ThumbsUp",
                    "TrashCan",
                    "Truck",
                    "Twinkle",
                    "Twitter",
                    "Undo",
                    "Upload",
                    "Utensils",
                    "VerticalEllipsis",
                    "VerticalExpand",
                    "Video",
                    "Yahoo",
                    "YahooColored",
                    "YouTube",
                    "ZoomIn",
                    "ZoomOut"
                ],
                defaultValue: "Account"
            },
            {
                name: "fontSize",
                type: "number",
                defaultValue: 14
            },
            {
                name: "color",
                type: "color"
            },
            {
                name: "direction",
                type: "string",
                enum: [
                    "up",
                    "down",
                    "left",
                    "right",
                    "upAndRight"
                ]
            }
        ]
    });
};
